import React, { useState, useEffect } from 'react';
import { RightOutlined } from "@ant-design/icons";
import { Row, Col, Button, Form, Input, Space } from "antd";
import bankMasterService from "../../../api/bank.service";
import { useDispatch } from 'react-redux';
import { addBank } from '../../../store/bankSlice';
import commonUtility from "../../../utility/Utils";
import CustomMessage from "../../common/CustomMessage";

const BankEntry = ({ data, onDrawerClose }) => {
    const dispatch = useDispatch();
    const [isFormResponse, setIsFormResponse] = useState(false);
    const [formResponseMessage, setFormResponseMessage] = useState("");
    const [formResponseStatus, setFormResponseStatus] = useState("");
    const [formDefaultValues, setFormDefaultValues] = useState({
        bank_id: data.bank_id,
        bank_name: data.bank_name,
        is_active: data.is_active,
        mode: data.mode
    });
    const [mode, setMode] = useState(data.mode);
    const [form] = Form.useForm();

    useEffect(() => {
        form.setFieldsValue(formDefaultValues);
    }, [formDefaultValues, form]);

    const hideResponseMessage = () => {
        setIsFormResponse(false);
        if (mode === "ADD") {
            form.resetFields();
            form.setFieldsValue({
                bank_id: formDefaultValues.bank_id,
                bank_name: formDefaultValues.bank_name,
                is_active: formDefaultValues.is_active,
                mode: formDefaultValues.mode,
            });
        }
    };

    const onBankSave = async (values) => {
        // console.log("values", values);
        const data = { formdata: values };
        // console.log("Saving bank data:", data);
        try {
            const resdata = await bankMasterService.save(data);
            // console.log("resdata", resdata);
            setIsFormResponse(true);
            setFormResponseStatus(resdata.response_status);
            setFormResponseMessage(resdata.response_msg);

            const x = {
                bank_id: values.bank_id,
                bank_name: values.bank_name,
                mode: values.mode,
                is_active: values.is_active
            };
            dispatch(addBank(x));
        } catch (error) {
            console.error("Error saving bank data:", error);
        }
    };

    return (
        <div>
            <div className="form-input-style">
                <Row className="" style={{ background: "transparent" }}>
                    <Col className="" xs={24} xl={24}>
                        <Form
                            form={form}
                            layout="vertical"
                            onFinish={onBankSave}
                            autoComplete="off"
                        >
                            <Row gutter={20}>
                                <Col xs={24} xl={24}>
                                    <Form.Item name="bank_name" label="Bank Name" rules={[
                                        {
                                            required: true,
                                            message: 'Bank name is required',
                                        },
                                    ]}>
                                        <Input placeholder="" />
                                    </Form.Item>
                                </Col>
                                <Col xs={24} xl={12}>
                                    <Form.Item name="bank_id" hidden>
                                        <Input type="hidden" />
                                    </Form.Item>
                                </Col>
                                <Col xs={24} xl={12}>
                                    <Form.Item name="is_active" hidden>
                                        <Input type="hidden" />
                                    </Form.Item>
                                </Col>
                                <Col xs={24} xl={12}>
                                    <Form.Item name="mode" hidden>
                                        <Input type="hidden" />
                                    </Form.Item>
                                </Col>
                                <Col xs={24} xl={12}>
                                    <Form.Item label=" ">
                                        <Space>
                                            <Button htmlType="submit" className="custom-button-green">
                                                Save <RightOutlined />
                                            </Button>
                                        </Space>
                                    </Form.Item>
                                </Col>
                            </Row>
                        </Form>
                    </Col>
                </Row>
                {isFormResponse && <CustomMessage title={formResponseStatus} subtitle={formResponseMessage} action={hideResponseMessage} onDrawerClose={onDrawerClose} mode={form.getFieldValue('mode')} />}
            </div>
        </div>
    );
};

export default BankEntry;
